import ContentConfig from '../config/ContentConfig';
import { PlayType } from '../common/constants';
import requestPlayType from '../common/utils/requestPlayType';
import { isPositive } from '../common/utils/numbers';

export const DEFAULT_TIMEOUT = 80000;

const positiveOrDefault = (value, defaultValue) => {
  return isPositive(value) ? value : defaultValue;
};

class PlaybackTimeout {
  constructor() {
    const config = ContentConfig.getInstance();
    const {
      timeoutAgentStreaming,
      timeoutAgentStreamingLive,
      timeoutAgentStreamingVod
    } = (config && config.legacy) || {};
    this.timeout = positiveOrDefault(timeoutAgentStreaming, DEFAULT_TIMEOUT);
    this.timeoutLive = positiveOrDefault(
      timeoutAgentStreamingLive,
      this.timeout
    );
    this.timeoutVOD = positiveOrDefault(timeoutAgentStreamingVod, this.timeout);
    this.promise = new Promise((_resolve, reject) => {
      this.reject = reject;
    });
  }

  init(delta, playType, url, sourceType) {
    return Promise.resolve(
      this.timeoutLive === this.timeoutVOD
        ? this.timeoutLive
        : Promise.resolve(
            playType != null ? playType : requestPlayType({ url, sourceType })
          )
            .then(type =>
              type === PlayType.LIVE ? this.timeoutLive : this.timeoutVOD
            )
            .catch(() => Math.min(this.timeoutLive, this.timeoutVOD)) // TODO: verify this with PO
    ).then(t => {
      t = Math.max(0, t - delta);
      setTimeout(this.reject, t, 't.a.s');
    });
  }

  getPromise() {
    return this.promise;
  }
}

export default PlaybackTimeout;
